let _ = require('lodash');
let { monkey } = require('baobab');
let { Query } = require('catberry-uri');
let windowUtils = require('../helpers/windowUtils');
let utils = require('../helpers/utils');

/**
 * Октрывает/закрывает popup в зависимости от аргумента name
 * @param {Object} args
 * @param {Object} state
 */
function togglePopupFromArgs ({ name }, state) {
    let path = ['popups', 'active'];
    let popups = state.get(path);

    if (_.includes(popups, name)) {
        state.set(path, []);
        return;
    }

    state.set(path, [name]);
}

module.exports = {
    /**
     * Установка значения по указаному пути
     *
     * @example utils.set('user.name', 'Федор Иванович')
     *
     * @param {String|Array} path
     * @param {*} value
     * @returns {Function}
     */
    set (path, value) {
        return function set (args, state) {
            let pathAsArray = _.isArray(path) ? path : path.split('.');
            var isEqual = _.isEqual(value, state.get(pathAsArray));

            if (isEqual) {
                return;
            }

            state.set(pathAsArray, value);
        };
    },

    /**
     * Удаляет значение по указанному пути
     *
     * @example utils.unset('user.name')
     *
     * @param {String|Array} template - lodash like path
     * @returns {Function}
     */
    unset (template) {
        let path = _.isArray(template) ? template : template.split('.');

        return function unset (args, state) {
            state.unset(path);
        };
    },

    /**
     * Переключение одного значения на другое
     * @param {String|Array} template
     * @returns {Function}
     */
    toggle (template) {
        let path = _.isArray(template) ? template : template.split('.');

        return function toggle (args, state) {
            var currentState = state.get(path);

            state.set(path, !currentState);
        };
    },

    /**
     * Устанавливает значение аргумента `argName`
     * @param {String} argName
     * @param {Object} value
     * @returns {Function}
     */
    setArg (argName, value) {
        return (args, state, output) => output({ [argName]: value });
    },

    setArgByFunction (argName, func) {
        return (args, state, output) => output({ [argName]: func(args) });
    },

    /**
     * Устанавливает значение аргумента `argName`
     * @param {String} argName
     * @param {Object} path
     * @returns {Function}
     */
    setArgFromState (argName, path) {
        return (args, state, output) => output({ [argName]: state.get(path) });
    },

    /**
     * Удобная функция для установки значения в <state>
     * Для удобства можно передать вторым аргуменом шаблон, а третьим выбрать из аргументов контекст
     *
     * @example utils.setFromArgsToState('textValue', 'user.${id}.name', { id: 'id'});
     * @example this.signal('signalName', { id: 10, textValue: 'Василий Петрович' }
     *
     * @param {String} argName
     * @param {String|Array} statePathTemplate
     * @param {Object} [context={}] - ключ это переменная в шаблоне, значение это путь до args
     * @returns {Function}
     */
    setFromArgsToState (argName, statePathTemplate, context = {}) {
        let pathArr = _.isArray(statePathTemplate) ? statePathTemplate : statePathTemplate.split('.');
        let pathTemplates = _.map(pathArr, _.template);

        return function setFromArgsToState (args, state) {
            let ctx = _.reduce(context, (obj, value, key) => {
                obj[key] = args[value];
                return obj;
            }, {});
            let path = _.map(pathTemplates, (pathFn) => pathFn(ctx));
            state.set(path, args[argName]);
        };
    },

    /**
     * Обновляем поля объекта по одному, чтобы не вызвать срабатывания compute при отстустсвии изменений
     * @param {String} argName
     * @param {Array} path
     * @returns {setFromArgsToState}
     */
    updateStateFromArg (argName, path) {
        return function setFromArgsToState (args, state) {
            let entity = args[argName];
            _.each(Object.keys(entity), (key) => {
                state.set(path.concat(key), entity[key]);
            });
        };
    },

    /**
     * Записывает значение из аргумента в URL без вызова сигнала
     * @param {String} argsKey
     * @param {String} queryKey
     * @return {Function}
     */
    patchURLQuery (argsKey, queryKey) {
        return function patchURLQuery (args, state, output, { context }) {
            let key = args[argsKey];
            let location = context.location.clone();

            if (!location.query) {
                location.query = new Query();
            }

            if (!location.query.values) {
                location.query.values = {};
            }

            location.query.values[queryKey] = key;
            let locationString = location.toString();
            context.redirect(utils.patchQueryWithUtm(locationString, state), { silent: true });
        };
    },

    /**
     * Записывает значение переданной строки в URL без вызова сигнала
     * @param {Array} statePath
     * @param {String} absPath
     * @return {Function}
     */
    queryRedirectFromState (statePath, absPath = '') {
        return function patchURLQuery (args, state, output, { context }) {
            let query = state.get(statePath);

            context.redirect(utils.patchQueryWithUtm(`${absPath}?${query}`, state), { silent: true });
        };
    },

    /**
     * Записывает в URL адрес выбранного заказа без вызова сигнала
     * @param {Array} statePath
     * @return {Function}
     */
    queryOrderRedirect (statePath) {
        return function patchURLQuery ({ orderId }, state, output, { context }) {
            if (context.isServer) {
                return;
            }
            let query = state.get(statePath);
            let role = state.get(['user', 'role']);
            let pageName = 'account';
            if (role === 'manager') {
                pageName = 'manager';
            }
            context.redirect(
                utils.patchQueryWithUtm(`/${pageName}/orders/${orderId}?${query}`, state),
                { silent: true });
        };
    },

    /**
     * Открывает popup с определенным именем
     * @param {String} name
     * @returns {Function}
     */
    openPopup (name) {
        return function openPopup (args, state) {
            var path = ['popups', 'active'];
            var current = state.get(path);
            var value = [name];

            if (_.isEqual(current, value)) {
                return;
            }

            state.set(path, value);
        };
    },

    /**
     * Добавляем еще одно всплывающее окно
     * @param {String} name
     * @returns {Function}
     */
    addPopup (name) {
        return function addPopup (args, state) {
            var path = ['popups', 'active'];
            state.concat(path, [name]);
        };
    },

    /**
     * Октрывает/закрывает popup с определенным именем
     * @param {String} name
     * @returns {Function}
     */
    togglePopup (name) {
        return function togglePopup (args, state) {
            togglePopupFromArgs({ name }, state);
        };
    },

    togglePopupFromArgs,

    /**
     * Промотать страницу вверх
     */
    scrollTop () {
        windowUtils.scrollTo(0, 200);
    },

    isPage (pageName) {
        return function patchURLQuery (args, state, output) {
            let currentPageName = state.get(['page', 'name']);
            if (pageName === currentPageName) {
                output.yes();
                return;
            }
            output.no();
        };
    },

    isLocalEditMode (args, state, output) {
        const role = state.get(['user', 'role']);
        const typeId = state.get(['account', 'orders', 'currentOrder', 'typeId']);

        if (role === 'unauthorized' || (role === 'manager' && typeId === 1)) {
            output.true();
        } else {
            output.false();
        }
    },

    isSaveLocalChanges (args, state, output) {
        let role = state.get(['user', 'role']);

        if (role === 'unauthorized') {
            output.yes();
            return;
        }

        output.no();
    },

    setArgToCookie (name, expiresMin) {
        return function (args, state, output, { context }) {
            if (args[name] !== undefined) {
                const expires = new Date(Date.now() + (expiresMin * 60 * 1000));
                context.cookie.set({
                    key: name,
                    value: args[name],
                    path: '/',
                    expires
                });
            }
        };
    },

    tryGetArgFromCookie (name) {
        return function (args, state, output, { context }) {
            let value = context.cookie.get(name);
            if (value && value.length > 0) {
                args[name] = value;
                output.success();
                return;
            }
            output.fail();
        };
    },

    unsetCookie (name) {
        return function (args, state, output, { context }) {
            const expires = new Date(Date.now() - 1000);
            context.cookie.set({
                key: name,
                value: '',
                path: '/',
                expires
            });
        };
    },

    /**
     * Добавляет элемент, если его нет в массиве
     * Удаляет элемент, если он есть в массиве
     */
    toggleItem (path, value) {
        return function (args, state) {
            let values = state.get(path) || new Array(0);
            let index = _.indexOf(values, value);
            if (index > -1) {
                state.unset(path.concat(index));
            } else {
                let newValues = _.clone(values);
                newValues.push(value);
                state.set(path, newValues);
            }
        };
    },

    toggleBool (path) {
        return function (args, state) {
            let value = state.get(path) || false;
            state.set(path, !value);
        };
    },

    toggleBoolFromArgs ({ path }, state) {
        let value = state.get(path) || false;
        state.set(path, !value);
    },

    throwErrorServer (args, state, output, { context }) {
        if (!context.isServer) {
            return;
        }
        throw Error('SERVER OSHIBKA UNHADLED');
    },

    consoleLog (message) {
        return function () {
            console.log(message);
        };
    },

    consoleLogArgs (args) {
        console.log(args);
    },

    consoleLogArg (name) {
        return function (args) {
            console.log(args[name]);
        };
    },

    consoleLogState (path) {
        return function (args, state) {
            console.log(state.get(path));
        };
    },

    setElementValue ({ id, path }, state) {
        let value = state.get(path);
        if (value !== undefined) {
            document.getElementById(id).value = value;
        }
    },

    setElementValueById (id, value) {
        return function (args, state) {
            let element = document.getElementById(id);
            if (element) {
                element.value = value;
            }
        }
    },

    setItemToLocalStorage (storageItemName, inputName) {
        return function (args, state, output, { context, locator }) {
            if (context.isServer) {
                return;
            }
            let window = locator.resolve('window');
            window.localStorage.setItem(storageItemName, JSON.stringify(args[inputName]));
        }
    },

    getItemFromLocalStorage (storageItemName, outputName) {
        return function (args, state, output, { context, locator }) {
            if (context.isServer) {
                output.unavailable();
                return;
            }
            let window = locator.resolve('window');
            let serialized = window.localStorage.getItem(storageItemName);

            if (!serialized) {
                output.notExists({});
                return;
            }

            let result = {};
            result[outputName] = null;
            try {
                result[outputName] = JSON.parse(serialized);
            } catch (e) {
                output.notExists({});
                return;
            }

            output.success(result);
        }
    },

    isArgEqual (argName, value) {
        return function (args, state, output) {
            if (args[argName] === value) {
                output.yes();
            } else {
                output.no();
            }
        }
    },

    isEqual (path, value) {
        return function (args, state, output) {
            if (state.get(path) === value) {
                output.yes();
            } else {
                output.no();
            }
        }
    },

    isDefined (path) {
        return function (args, state, output) {
            if (state.get(path)) {
                output.yes();
            } else {
                output.no();
            }
        };
    },

    isObjectDefinedAndNotEmpty (path) {
        return function (args, state, output) {
            let value = state.get(path);
            if (value && Object.keys(value).length !== 0) {
                output.yes();
            } else {
                output.no();
            }
        };
    },

    isArgNotNull (argName) {
        return function (args, state, output) {
            if (args[argName]) {
                output.yes();
            } else {
                output.no();
            }
        };
    },

    isArgsEqual (arg1, arg2) {
        return function (args, state, output) {
            if (args[arg1] === args[arg2]) {
                output.yes();
            } else {
                output.no();
            }
        };
    },

    isConditionTrue (path, value, condition) {
        return function (args, state, output) {
            if (condition(state.get(path), value)) {
                output.yes();
            } else {
                output.no();
            }
        }
    },

    /**
     * Меняем disabled для html-element по id
     */
    toggleElementById (id) {
        return function () {
            let element = document.getElementById(id);
            if (element) {
                element.disabled = !element.disabled;
            }
        };
    },

    /**
     * Меняем disabled для html-element по id
     */
    setElementVisibilityById (id, value) {
        return function () {
            let element = document.getElementById(id);
            if (element) {
                element.style.visibility = value;
            }
        };
    },

    /**
     * Устанавливаем видимость для определенного popup'а
     * @param {String} name
     * @param {Array} path
     * @returns {Function}
     */
    setPopupVisibility (name, path) {
        return function (args, state) {
            state.set(path, monkey([
                ['popups', 'active'],
                (popups) => _.includes(popups, name)
            ]));
        };
    },

    logOnWebApi (message, level) {
        return (args, state, output, { locator, context }) => {
            let api = locator.resolve('api');
            let user = state.get(['user']);
            let request = api.logOnWebApi(context, locator, { level,
                message: `${message} ${JSON.stringify(user)}` });

            request.then((response) => {
                let code = _.get(response, 'status.code');
                if (code !== 200) {
                    output.error({ error: code });
                }
            })
            .catch((error) => {
                output.error({ error });
            });
        };
    },

    checkIsCookieEnabled (args, state, output, { context }) {
        if (context.isServer) {
            output.server();
            return;
        }
        let expires = new Date(Date.now() + (60 * 1000));
        let key = 'datumlib.test.cookie';
        context.cookie.set({
            key: key,
            value: key,
            path: '/',
            expires
        });
        if (context.cookie.get(key)) {
            output.yes();
            return;
        }
        output.no();
    }
};



// WEBPACK FOOTER //
// ./actions/utils.js